import { AxiosInstance } from "axios";
import type { NotionPage } from "./NotionSourceSettings.types";

export class NotionSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getPages(
    boardId: string,
    connectionId: string,
    searchTerm: string,
  ): Promise<NotionPage[]> {
    const response = await this.client.get<NotionPage[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/notion/pages?searchTerm=${encodeURIComponent(searchTerm)}`,
    );
    return response.data;
  }
}
